export default __webpack_public_path__ + "static/media/11_HOCOM.fd33bca8.png";